(function() {
    'use strict';
    angular.module('Const').constant('DriverGroupTypes', [
        'DRIVERGROUP'
    ]);
})();



// WEBPACK FOOTER //
// ./js/consts/driverGroupTypeConst.js